import { useEffect } from "react";
import { Player } from "./playback/Player";
import { startController } from "./runtime/controller";
import { PairingScreen } from "./screens/PairingScreen";
import { ErrorScreen, LoadingScreen, NoticeOverlay } from "./screens/StatusScreen";
import { usePlayerStore } from "./state/playerStore";

export function App() {
  const provisioning = usePlayerStore((s) => s.provisioning);

  useEffect(() => {
    void startController();
  }, []);

  switch (provisioning) {
    case "active":
      return (
        <>
          <Player />
          <NoticeOverlay />
        </>
      );
    case "pairing":
      return <PairingScreen />;
    case "error":
      return <ErrorScreen />;
    default:
      return <LoadingScreen message="Registering device…" />;
  }
}
